import { supabase } from "../supabase/supabase";

interface IGame {
    id?: string;
    status?: number; // 0 - not started, 1 - started, 2 - ended by host, 3 - ended for not having enough players
    startTime?: number;
    stats?: number;
}

export class Game {
    id: string;
    status: number;
    startTime: number;
    stats: number;

    constructor(id: string, status: number, startTime: number, stats: number) {
        this.id = id;
        this.status = status;
        this.startTime = startTime;
        this.stats = stats;
    }

    static fromJson(json: IGame) {
        return new Game(
            json.id ? json.id as string : "",
            json.status ? json.status as number : 0,
            json.startTime ? json.startTime as number : 0,
            json.stats ? json.stats as number : 0,
        );
    }

    static async addNewGame(newGameId: string, startTime: number, statsId: number) {
        const { data, error } = await supabase
            .from("Games")
            .insert({
                id: newGameId,
                status: 0,
                startTime: startTime,
                stats: statsId
            })
            .select(`id`);
        return Game.fromJson(data![0]);
    }

    static async updateGameStatus(gameId: string, newStatus: number) {
        const { error } = await supabase
            .from("Games")
            .update({ status: newStatus })
            .eq("id", gameId);
    }

    static async deleteGame(gameId: string) {
        await supabase
            .from("Games")
            .delete()
            .eq("id", gameId);
    }

    static async getGames(gameId: string) {
        const games = [];
        const { data, error } = await supabase
            .from("Games")
            .select(`
                id,
                status,
                stats
                `)
            .eq("id", gameId);

        for (let idx = 0; idx < data!.length; idx++) {
            const game = this.fromJson(data![idx]);
            games.push(game);
        }

        return games;
    }
}